import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Metrics from './components/Metrics';
import Services from './components/Services';
import Products from './components/Products';
import Features from './components/Features';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Metrics />
      <Services />
      <Products />
      <Features />
      <Footer />
    </div>
  );
}

export default App;
